import type { DeploySceneConfig } from '../../platform/scenes/types';
import { MS_MODULES } from './modules';

export const MS_ALL_MODULES = MS_MODULES.map((m) => m.key);

/** SKU / 下单可见模块（不含基本信息） */
export const MS_SKU_MODULE_KEYS = ['modelProvider', 'other'] as const;

export type MsSkuModuleKey = (typeof MS_SKU_MODULE_KEYS)[number];

export const MS_SKU_MODULE_LIST: string[] = [...MS_SKU_MODULE_KEYS];

const MS_SKU_MODULE_KEY_SET = new Set<string>(MS_SKU_MODULE_KEYS);

export function filterMsSkuModules<T extends { key: string }>(modules: readonly T[]): T[] {
  return modules.filter((mod) => MS_SKU_MODULE_KEY_SET.has(mod.key));
}

export const MS_SCENES: Record<'direct' | 'sku' | 'order', DeploySceneConfig> = {
  direct: {
    modules: [...MS_ALL_MODULES],
    linkage: false,
  },
  sku: {
    modules: [...MS_SKU_MODULE_KEYS],
    linkage: false,
  },
  order: {
    modules: [...MS_SKU_MODULE_KEYS],
    linkage: false,
  },
};

export function resolveMsSceneConfig(scene?: 'direct' | 'sku' | 'order'): DeploySceneConfig {
  return MS_SCENES[scene ?? 'direct'];
}

export interface MsDirectCreateStep {
  key: string;
  title: string;
  modules: string[];
}

/** 直建合并「资源配置」步：基本信息 + 模型供应商 + 高级设置 */
export const MS_DIRECT_MERGED_MODULES = ['baseInfo', 'modelProvider', 'other'] as const;

export type MsDirectMergedModuleKey = (typeof MS_DIRECT_MERGED_MODULES)[number];

export const MS_DIRECT_CREATE_STEPS: MsDirectCreateStep[] = [
  { key: 'resource', title: '资源配置', modules: [...MS_DIRECT_MERGED_MODULES] },
];

export function filterMsDirectMergedModules<T extends { key: string }>(modules: readonly T[]): T[] {
  const keys = new Set<string>(MS_DIRECT_MERGED_MODULES);
  return modules.filter((mod) => keys.has(mod.key));
}
